import { createContext } from 'react';

const WhereBuyContext = createContext(void 0);

WhereBuyContext.displayName = 'context(whereBuy)';

export default WhereBuyContext;